import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {};
  },
  props: ['imgs'],
  methods: {},
  mounted() {
    this.$nextTick(() => {
      new Swiper(this.$refs.swiperBigImg, {
        pagination: {
          el: '.swiper-pagination'
        },
        slidesPerView: 'auto',
        initialSlide: 0,
        centeredSlides: true,
        runCallbacksOnInit: false,
        touchMoveStopPropagation: true,
        slideToClickedSlide: true,
        observer: true,
        observeSlideChildren: true
      });
    });
  },
  created() {
    console.log(this.imgs);
  },
  computed: {}
};